import { getUserPermissions } from "Bands/state";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { User } from "shared/assets/icons";
import { Button, FormBuilder, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon, MutedDarkText } from "shared/styles";
import { ContentWidth } from "shared/styles/constants";
import { IFieldType, ITheme } from "shared/types";
import { forceIsDirtyAtom } from "../permissions/state/permissions";
import { useSetAtom } from "jotai";

interface Props {
  selectedMemberId: string;
  setForceUserId: (id: string) => void;
}

const CopyPermissionsModal: FC<Props> = ({ selectedMemberId, setForceUserId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const setForceIsDirty = useSetAtom(forceIsDirtyAtom);

  const dispatch = useDispatch();

  const onSubmit = ({ user }: { user: string }) => {
    setForceUserId(user);
    dispatch(getUserPermissions(user));
    setForceIsDirty(true);
    // (async () => {
    //   const data = await PermissionsService.getUserPermissions(user);

    //   const mappedResult = (
    //     Object.values(data.bandUser)[0].attributes?.[
    //       "permissions"
    //     ] as IJSONAPIData[]
    //   ).map((permission) => {
    //     return permission.data.attributes;
    //   }) as unknown as IPermission[];

    //   setImportPermissions(mappedResult);
    // })();
  };

  return (
    <>
      {isModalOpen && (
        <Modal
          title={"Import permissions from another member"}
          icon={User}
          handleClose={() => setIsModalOpen(false)}
          width={ContentWidth.default}
          showCloseButton
        >
          <Spacer size="l">
            <MutedDarkText>
              Please select a source member from the list below to use their permissions as a
              starting point for configuring the current member's permissions.
            </MutedDarkText>
            <FormBuilder
              fields={[
                {
                  name: "user",
                  label: "Select Source Member",
                  type: IFieldType.singlePeoplePicker,
                  validation: {
                    required: true,
                  },
                  settings: {
                    includeInvitedUsers: true,
                    excludeOptions: [selectedMemberId],
                  },
                  placeholder: "Select a member",
                  isSearchable: false,
                },
              ]}
              buttons={{
                primary: {
                  children: "Import Permissions",
                },
                secondary: {
                  onClick: () => setIsModalOpen(false),
                },
              }}
              onSubmit={onSubmit}
              submitMode="isDirty"
            />
          </Spacer>
        </Modal>
      )}

      <Spacer size="s" spaceDirection="horizontal" align="center">
        <Button onClick={() => setIsModalOpen(true)} theme={ITheme.secondary} size="m">
          <Icon as={User} />
          <span>Import permissions from another member</span>
        </Button>
      </Spacer>
    </>
  );
};

export default CopyPermissionsModal;
